import dayjs from 'dayjs';
import { useQuery } from 'react-query';
import { API } from 'api';
import { useSelector } from 'react-redux';
import { RootState } from 'modules';
import { PermissionId, checkAccessPermission } from 'common';

export interface ITransactionListData {
  payload: {
    page?: number;
    eid?: string;
    uid?: string;
    employeeId?: string;
    employmentName?: string;
    trxRef?: string;
    paymentsToBankId?: string;
    trxType?: string;
    mobile?: string;
    dateFrom?: number;
    dateTo?: number;
    download: boolean;
  };
  data: {
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    data: any;
    count: number;
  };
}

export const initTransactionListPayload: ITransactionListData['payload'] = {
  page: 1,
  dateFrom: dayjs().startOf('month').unix(),
  dateTo: dayjs().unix(),
  download: false,
};

const getTransactionList = (data: ITransactionListData['payload']) => {
  return API.get()('/api/admin/transactions/retrieve', data);
};

export const useTransactionListData = (data: ITransactionListData['payload']) => {
  const permissions = useSelector((state: RootState) => state.user.permissions);

  // Check if we have the minimum required data to make a meaningful API call
  const hasValidParams = () => {
    // Always allow queries with date range (normal transaction list behavior)
    if (data.dateFrom || data.dateTo) {
      return true;
    }

    // Allow if any meaningful search parameter is provided
    if (
      data.uid ||
      data.eid ||
      data.employeeId ||
      data.trxRef ||
      data.paymentsToBankId ||
      data.mobile ||
      data.trxType
    ) {
      return true;
    }

    // Disable query if no meaningful parameters are provided
    return false;
  };

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  return useQuery(['transactions', data], (): any => getTransactionList(data), {
    enabled:
      checkAccessPermission(permissions, [
        PermissionId.EMPLOYEE_TRANSACTION_READ,
        PermissionId.PAYMENT_TRANSACTION_READ,
      ]) && hasValidParams(),
    select: (response: ITransactionListData['data']) => {
      return response.data;
    },
  });
};
